export default {
  ...process.env,
};



// WEBPACK FOOTER //
// ./src/config/env.js